import { z } from 'zod';

/**
 * These values are passed to the snapshot odata api's via the url to apply additional custom server-side filtering.
 * @see Manzanita.Web.Features.Snapshot.SnapshotPerspectiveFilters */
export interface CommonFilters {
	warehouseId?: number | null | undefined;
	countryCode?: string | null | undefined;
	customerGroupId?: number | null | undefined;
	customerId?: number | null | undefined;
	productCategoryId?: number | null | undefined;
	userRoleId?: number | null | undefined;
	userId?: number | null | undefined;
	allAssociationsOnly?: boolean | null | undefined;
}

/**
 * These values are passed to the snapshot odata api's via the url to apply additional custom server-side filtering.
 * @see Manzanita.Web.Features.Snapshot.SnapshotPerspectiveFilters */
export const commonFiltersSchema = z.object({
	warehouseId: z.number().optional().nullable(),
	countryCode: z.string().optional().nullable(),
	customerGroupId: z.number().optional().nullable(),
	customerId: z.number().optional().nullable(),
	productCategoryId: z.number().optional().nullable(),
	userRoleId: z.number().optional().nullable(),
	userId: z.number().optional().nullable(),
	allAssociationsOnly: z.boolean().optional().nullable(),
}) satisfies z.ZodType<CommonFilters> as z.ZodType<CommonFilters>;
